export default __webpack_public_path__ + "static/media/15.6534ab2c.mp3";